import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getEvents} from "../../store/cabinet/action";
import {useNavigate} from "react-router-dom";
import CabinetEventsMain from "../../components/cabinetEventsMain";
import CabinetEventsTable from "../../components/cabinetEventsTable";



const CabinetEventsPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {
        dispatch(getEvents());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetEventsMain/>
                <CabinetEventsTable/>
            </div>
        </section>
    );
};

export default CabinetEventsPage;
